'use client';

import { useState, useEffect } from 'react';

export const useOtpTimer = (expirationInSeconds?: number, resetKey?: string) => {
  const [timer, setTimer] = useState(0);

  // Re-start when duration or OTP session changes (e.g. resend returns new expirationDate)
  useEffect(() => {
    if (expirationInSeconds) {
      setTimer(expirationInSeconds);
    }
  }, [expirationInSeconds, resetKey]);

  // Countdown
  useEffect(() => {
    if (!timer) return;

    const id = setInterval(() => {
      setTimer((t) => t - 1);
    }, 1000);

    return () => clearInterval(id);
  }, [timer]);

  return { timer, setTimer };
};
